export enum DispositionTypes {
  FETCH_DISPOSITION_REQUEST = 'app/analytics/FETCH_DISPOSITION_REQUEST',
  FETCH_DISPOSITION_SUCCESS = 'app/analytics/FETCH_DISPOSITION_SUCCESS',
  FETCH_DISPOSITION_FAILURE = 'app/analytics/FETCH_DISPOSITION_FAILURE',
}
